<script>
	import { _ } from "svelte-i18n"
	import {hero_expanded, text_entered_once, user} from '../stores'
	import Header from "./Header.svelte";
	import HeroTitle from "./HeroTitle.svelte";
	import TextArea from './TextArea.svelte'
	import HeroImage from "./HeroImage.svelte"
	import TypeQuotes from './TypeQuotes.svelte'

</script>

<section class="hero" class:expanded={$hero_expanded}>
	<Header />
	{#if $user === undefined}
		<HeroTitle />
	{:else if !$text_entered_once}
		<TypeQuotes />
	{/if}

	<TextArea />
	
	{#if $user === undefined}
		<HeroImage />
	{/if}
</section>

<style>
	.hero {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 8rem;
		margin-top: 0;
		padding: 2rem 12rem;
		background-color: var(--c-accent-fill);
		transition: all var(--transition-props);
	}

	.hero.expanded {
		height: Calc(100vh - 8rem);
		min-height: 42rem;
	}

	@media only screen and (max-width: 1024px) {
		.hero {
			padding: 0 4rem !important;
		}
	}

</style>